import { createRoot } from 'react-dom/client';
import { ConfigProvider, Empty } from 'antd';
import cs_CZ from 'antd/es/locale/cs_CZ';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { initializeStore } from 'myredux/store';
//import { makeServer } from "./mirage";
import reportWebVitals from './reportWebVitals';

import './index.css';

import App from './App';
import Fallback from 'components/fallback/fallback';

const config = {
  "token": {
    "colorPrimary": "#db0036",
    "colorInfo": "#db0036"
  },
  "components": {
    "Button": {
      "defaultBorderColor": "rgba(92,110,143,0.5)",
      "defaultColor": "rgba(92,110,143,0.75)",
      "defaultHoverBg": "rgba(111,130,160,0.15)",
      "defaultHoverBorderColor": "rgb(111,130,160)",
      "defaultHoverColor": "rgb(92,110,143)",
      "primaryShadow": ""
    },
    "Select": {
      "activeBorderColor": "rgb(219,0,54)",
      "hoverBorderColor": "rgb(92,110,143)",
      "colorBorder": "rgba(92,110,143,0.5)",
      "colorTextPlaceholder": "rgba(92,110,143,0.25)"
    },
    "DatePicker": {
      "activeBorderColor": "rgb(219,0,54)",
      "hoverBorderColor": "rgb(92,110,143)",
      "colorBorder": "rgba(92,110,143,0.5)",
      "colorTextPlaceholder": "rgba(92,110,143,0.25)",
      "controlItemBgActive": "rgba(111,130,160,0.15)"
    },
    "Upload": {
      "colorText": "rgb(92,110,143)",
      "colorBgMask": "rgba(111,130,160,0.15)"
    }
  }
};

if (process.env.NODE_ENV === "development") {
  //makeServer();
}

const { store, persistor } = initializeStore();

const app = (
  <ConfigProvider locale={cs_CZ} theme={config} renderEmpty={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Žádná data k zobrazení'/>}>
    <Provider store={store}>
      <PersistGate loading={<Fallback />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ConfigProvider>
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element.');
const root = createRoot(rootElement);
root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
